import { useMutation } from '@tanstack/react-query';
import { UserService } from 'src/services/api/UserService';

// For logout (mutation)
export function useLogoutUser() {
  return useMutation({
    mutationKey: ['logoutUser'],
    mutationFn: (logoutData) => UserService.logoutUser(logoutData),
  });
}
